import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ===== MOBILE VIEWPORT FIX =====
// The viewport meta tag is ONLY read during initial HTML parse.
// If stale cached HTML was served without our viewport fix,
// changing it via JS does nothing — we must force a page reload.
(function() {
  // 1. Ensure the meta tag is correct for next load
  const needed = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';
  let vp = document.querySelector('meta[name="viewport"]');
  if (!vp) {
    vp = document.createElement('meta');
    vp.name = 'viewport';
    document.head.appendChild(vp);
  }
  vp.content = needed;

  // 2. Nuke old CACHING service workers (but keep push SW!)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(r) {
      r.forEach(function(reg) {
        // Only unregister the main caching SW, NOT the push notification SW
        if (reg.active && reg.active.scriptURL && reg.active.scriptURL.includes('sw-push')) return;
        reg.unregister();
      });
    });
  }
  if ('caches' in window) {
    caches.keys().then(function(n) { n.forEach(function(k) { caches.delete(k); }); });
  }

  // 3. Detect mobile device rendering at desktop width → force reload
  var isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    ('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0);
  var tooWide = window.innerWidth > 600 && screen.width <= 500;

  if (isMobile && tooWide) {
    // Page rendered at desktop width on a mobile device.
    // Use URL param to prevent infinite reload loop.
    var url = new URL(window.location.href);
    if (!url.searchParams.has('_vf')) {
      url.searchParams.set('_vf', '1');
      window.location.replace(url.toString());
      return; // Stop — page will reload with correct viewport
    }
  }

  // Clean up URL param after successful fix
  if (window.location.search.indexOf('_vf=') !== -1) {
    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('_vf');
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.hash);
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
